// Hands the pin (coordinates and name, never the address) to the phone's own maps app.
export function mapsLink({ lat, lng, name }, { userAgent = '', maxTouchPoints = 0 } = {}) {
  const q = encodeURIComponent(name);
  if (/iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1)) {
    return `https://maps.apple.com/?ll=${lat},${lng}&q=${q}`;
  }
  // The label sits in brackets, which encodeURIComponent leaves as they are.
  if (/Android/.test(userAgent)) return `geo:${lat},${lng}?q=${lat},${lng}(${q.replace(/\(/g, '%28').replace(/\)/g, '%29')})`;
  return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=17/${lat}/${lng}`;
}
